@if (popupMode) {
    <div class="language-dialog">
        <div class="section-header" mat-dialog-title>
            <mat-icon class="section-icon">translate</mat-icon>
            <span class="section-title">{{ 'account.language' | transloco }}</span>
        </div>

        <div class="search-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input
                type="text"
                class="search-input"
                [(ngModel)]="searchText"
                (input)="filterLanguages()"
                placeholder="{{ 'ai.search' | transloco }}..."
                autocomplete="off"
            />
            @if (searchText) {
                <button mat-icon-button class="clear-button" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>

        <div class="languages-list">
            <cdk-virtual-scroll-viewport [itemSize]="56" class="languages-viewport">
                @for (item of filteredLanguages; track item.code) {
                    <div class="language-item" (click)="selectLocal(item)" [class.selected]="isSelected(item)">
                        <div class="language-content">
                            <div class="language-native">{{ item.lang }}</div>
                            <div class="language-english">{{ item.local }}</div>
                        </div>
                        @if (isSelected(item)) {
                            <mat-icon class="check-icon">check_circle</mat-icon>
                        }
                    </div>
                }
            </cdk-virtual-scroll-viewport>
        </div>

        <div class="dialog-footer">
            <span class="languages-count">{{ filteredLanguages.length }} {{ 'ai.languages' | transloco }}</span>
        </div>
    </div>
}

@if (!popupMode) {
    @if (!setLargeMode) {
        @if (!iconButton) {
            <a (click)="onOpenDialog()" class="local-icon">
                <mat-icon matTooltip="{{'account.language' | transloco}}">translate</mat-icon>
            </a>
        }
        @if (iconButton) {
            <button mat-icon-button (click)="onOpenDialog()">
                <mat-icon matTooltip="{{'account.language' | transloco}}">translate</mat-icon>
            </button>
        }
    }
    @if (setLargeMode) {
        <div style="width: 100%; position: relative;">
            <button mat-button [matMenuTriggerFor]="profileMenu">
                <mat-icon>translate</mat-icon>
                <span style="margin-left: 5px">language</span>
            </button>
            <mat-menu #profileMenu>
                @for (item of localCodes; track item) {
                    <button mat-menu-item (click)="selectLocal(item)">{{ item.lang }}</button>
                }
            </mat-menu>
        </div>
    }
}

